import { render, staticRenderFns } from "./calendar-loader.vue?vue&type=template&id=0d936a30"
import script from "./calendar-loader.vue?vue&type=script&lang=js"
export * from "./calendar-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports